module.exports = __webpack_public_path__ + "static/dlm_bck2-cd58b20e1b38b0f10f597bb0071667bc.png";